import locale from "./locales/en";
import { blockScreen } from "./common";
import { IAlertProps } from "./types";

export function confirm(props: IAlertProps) {
	const apply = props.buttons && props.buttons[0] ? props.buttons[0] : locale.apply;
	const reject = props.buttons && props.buttons[1] ? props.buttons[1] : locale.reject;

	const unblock = blockScreen(props.blockerCss);

	return new Promise((res) => {
		const answer = (val) => {
			unblock();
			confirmBox.removeEventListener("click", clickHandler);
			document.body.removeChild(confirmBox);
			res(val);
		};
		const confirmBox = document.createElement("div");
		confirmBox.className = "dhx_widget dhx_alert dhx_alert--confirm" + (props.css ? " " + props.css : "");

		confirmBox.innerHTML = `
		${props.header ? `<div class="dhx_alert__header"> ${props.header} </div>` : ""}
		${props.text ? `<div class="dhx_alert__content">${props.text}</div>` : ``}
			<div class="dhx_alert__footer ${props.buttonsAlignment ? ("dhx_alert__footer--" + props.buttonsAlignment) : ""}">
				<button class="dhx_alert__confirm-aply dhx_button dhx_button--view_link dhx_button--color_primary dhx_button--size_medium">${apply}</button>
				<button class="dhx_alert__confirm-reject dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium">${reject}</button>
			</div>`;
		document.body.appendChild(confirmBox);
		(confirmBox.querySelector(".dhx_alert__confirm-reject") as HTMLElement).focus();

		const clickHandler = e => {
			if ((e.target as HTMLElement).tagName === "BUTTON") {
				answer((e.target as HTMLElement).classList.contains("dhx_alert__confirm-aply"));
			}
		};

		confirmBox.addEventListener("click", clickHandler);
	});
}